import script from "./SupervisorMobileBottomNav.vue?vue&type=script&setup=true&lang=js"
export * from "./SupervisorMobileBottomNav.vue?vue&type=script&setup=true&lang=js"

import "./SupervisorMobileBottomNav.vue?vue&type=style&index=0&id=a5a6642c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5a6642c"]])

export default __exports__